import { ConsumerConstants as Constants } from '../types'
import { consumerApi as api } from '../../api'

export const consumerAction = {
    get,
    add,
    update,    
    import_data,    
    export_data,
    remove,
    bulkRemove,
    clear,
};

function get(offset, data, page_size) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._get(offset, data, page_size)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        // reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.GET, payload } }    
    function failure(error) { return { type: Constants.FAIL, error } }
}

function add(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._add(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.ADD, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function update(data, id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._update(data,id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.UPDATE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}

function import_data(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._import_data(data)
                .then(
                    payload => {
                        dispatch(success(payload?.data ?? payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.GET, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}


function export_data(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._export_data(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.EXPORT, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}



function remove(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._delete(id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.DELETE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}



function bulkRemove(ids) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._bulkDelete(ids)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.DELETE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}


function clear() {
    return dispatch => {   
        return new Promise((resolve, reject) => {     
            dispatch(success());
            resolve()
        })   
    }
    function success() { return { type: Constants.CLEAR } }
}